import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ContactComponent } from './contact.component';
import { SidebarService } from '@ibe/services/ui';
import { CountryCode } from '@ibe.models/country-code.model';
import { Subscription, Observable } from 'rxjs';
import { Router } from '@angular/router';

import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';

@Component({
	selector: 'app-contact',
	templateUrl: './contact.indra.component.html',
	styleUrls: ['./contact.component.css']
})
export class INDRAContactComponent extends ContactComponent implements OnInit, OnDestroy {

	contacts: any;
	countryCodes: Array<CountryCode>;
	allSubs: Subscription[] = [];
	private _has_details = false;
	booked_trip;
	contactsCreated = false;
	
	@Input()
	no_edit = false;

	@Input()
	pnr;

	constructor(
		private sidebarService: SidebarService,
		private bfmStorage: INDRABFMDataStorageService,
		private ibeAdminService: INDRAIbeAdminService,
		private router: Router,
		private parallelService: INDRAParallelService,
	) {
		super();
		
		if (this.bfmStorage.INDRA_getCountryCodes()) {
			this.countryCodes = this.bfmStorage.INDRA_getCountryCodes();
		}
		this.INDRA_assignValues();
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
	}
	
	/**
	 * get the list of phone numbers to print
	 *
	 * @param {*} values
	 * @returns
	 * @memberof INDRAContactComponent
	 */
	INDRA_getPhoneNumbers(values) {
		let primaryPrefixValue = '';
		var plusSign = new RegExp("\\+"); // + sign
		if (values.phoneCountryCode) {
			primaryPrefixValue = values.phoneCountryCode.search(plusSign) == 0 ? values.phoneCountryCode : '+' + values.phoneCountryCode;
		}
		return primaryPrefixValue + values.phone;
	}
	
	/**
	 * Get booking secondary phone contact details
	 * returns the array of the secondary phone numbers
	 *
	 * @param {string} dialCode
	 * @param {*} secondaryPhones
	 * @returns
	 * @memberof INDRAContactComponent
	 */
	INDRA_getSecondaryPhoneNumbersObject(secondaryPhones) {
		const newSecondaryPhoneNumbers = [];

		if (secondaryPhones && secondaryPhones['secondaryTelephones'] && secondaryPhones['secondaryTelephones'].length > 0) {
			secondaryPhones.secondaryTelephones.forEach((element, index) => {
				// const dialCode = this.INDRA_getDialCode(element.countryCode);
				if (index == 0) {
					var plusSign = new RegExp("\\+"); // + sign
					let dialCode = null;
					if (element.countryCode) {
						dialCode = element.countryCode.search(plusSign) == 0 ? element.countryCode : '+' + element.countryCode;
					}

					if (dialCode) {
						newSecondaryPhoneNumbers.push(dialCode + element.telephone);
					} else {
						newSecondaryPhoneNumbers.push(element.telephone);
					}
				}
			});
		}

		return newSecondaryPhoneNumbers.join('; ');
	}
	
	/**
	 * Get the dial code of a country
	 *
	 * @param {*} countryCode
	 * @returns {string}
	 * @memberof INDRAContactComponent
	 */
	INDRA_getDialCode(countryCode): string {
		const country = this.countryCodes.find(item => item.code === countryCode);
		return country ? country.dial_code : '';
	}
	
	ngOnInit() {
		const currentBookingSubscription = this.bfmStorage.observableCurrentBooking.subscribe(
			(data) => {
				this.INDRA_assignValues();
			}
		);
		this.allSubs.push(currentBookingSubscription);
	}
	
	/**
	 * Check if booking already has contact details
	 */
	INDRA_hasContactDetails(): boolean {
		return this._has_details;
	}
	
	/**
	 * Prints label of link to add/edit contact details
	 */
	INDRA_printLinkLabel() {
		return this.INDRA_getTranslation(this.INDRA_printLinkLabelKey());
	}

	INDRA_printLinkLabelKey() {
		return this._has_details ? 'bookingDetails.link.editContact' : 'bookingDetails.link.addContact';
	}
	
	/**
	 * Prints CSS classes of link
	 */
	INDRA_printLinkClasses() {
		return {
			display: !this._has_details ? 'block' : 'flex'
		};
	}
	
	/**
	 * Prints contact details box label
	 */
	INDRA_printLabel(contact) {
		return contact.label;
	}
	
	/**
	 * Has contact value
	 */
	INDRA_hasContactValue(contact): boolean {
		return contact.value !== undefined && contact.value !== '';
	}
	
	/**
	 * Prints contact value (phone number or email, ...)
	 */
	INDRA_printContactValue(contact) {
		return contact.value;
	}
	
	/**
	 * Prints contact label (phone number or email, ...)
	 */
	INDRA_printContactLabel(contact) {
		return contact.label;
	}
	
	/**
	 * Prints contact details box description
	 */
	INDRA_printDescription(contact) {
		return contact.description;
	}
	
	/**
	 * Tells if is first or last contact
	 */
	INDRA_shouldShow(index): boolean {
		const shouldShow = index === this.contacts.length - 1 || index === 0;

		if (shouldShow && !this.contactsCreated) {
			this.parallelService.INDRA_setIsContactCreated(true);

			this.contactsCreated = true;
		}

		return shouldShow
	}
	
	/**
	 * Open Sidebar
	 */
	INDRA_handleOpenSidebar() {
		this.sidebarService.openSidebar(['contacts', { pnr: this.pnr }]);
	}
	
	INDRA_getTranslation(key: string): Observable<string> {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}
	
	INDRA_assignValues() {
		if (this.bfmStorage.INDRA_getActiveBookInfoPax()) {
			const infoPax = this.bfmStorage.INDRA_getActiveBookInfoPax();
			this.INDRA_getSecondaryPhoneNumbersObject(infoPax);
			let PHONES = [{
				label: this.INDRA_getTranslation('bookingDetails.label.primaryPhone'),
				labelKey: 'bookingDetails.label.primaryPhone',
				value: this.INDRA_getPhoneNumbers(infoPax) === 'null' || !this.INDRA_getPhoneNumbers(infoPax) ? ' ' : this.INDRA_getPhoneNumbers(infoPax)
			},
			{
				label: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? this.INDRA_getTranslation('bookingDetails.label.secondaryPhone') : '',
				labelKey: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? 'bookingDetails.label.secondaryPhone' : '',
				value: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? this.INDRA_getSecondaryPhoneNumbersObject(infoPax) : ''
			}];
			
			if (!infoPax.phone && !infoPax.prefixPhone && !infoPax.email) {
				this._has_details = false;
			} else {
				this._has_details = true;
			}
			
			this.contacts = [
				{
					label: this.INDRA_getTranslation('bookingDetails.label.email'),
					labelKey: 'bookingDetails.label.email',
					values: [
						{
							label: this.INDRA_getTranslation('bookingDetails.label.email'),
							labelKey: 'bookingDetails.label.email',
							value: infoPax.email
						}
					],
					description: this.INDRA_getTranslation('bookingDetails.text.confirmationEmail'),
					descriptionKey: 'bookingDetails.text.confirmationEmail',
				},
				{
					label: this.INDRA_getTranslation('bookingDetails.label.phoneNumber'),
					labelKey: 'bookingDetails.label.phoneNumber',
					values: PHONES,
					description: this.INDRA_getTranslation('bookingDetails.text.contactPhone'),
					descriptionKey: 'bookingDetails.text.contactPhone',
				}
			];
		}
	}
	
	INDRA_isGroupBooking() {
		return this.booked_trip.data.group;
	}

	ngOnDestroy() {
		for (let sub of this.allSubs) {
			sub.unsubscribe();
		}
	}
}
